/*
 * Project: BookingEngine
 * Module: components/booking/confirmation/Control.js
 * vim:ft=javascript.jsx:
 */
import React from 'react';
import PropTypes from 'prop-types';

import '../../static/less/global/forms.less';

class FormControl extends React.Component {
  constructor(props) {
    super(props);

    this.isIn = this.isIn.bind(this);
    this.isOut = this.isOut.bind(this);
    this.onBlur = this.onBlur.bind(this);

    this.state = {
      focused: false,
    };
  }

  isIn() {
    this.setState({ focused: true });
  }

  isOut() {
    this.setState({ focused: false });
  }

  onBlur() {
    this.setState({ focused: false });
  }

  // eslint-disable-next-line default-param-last
  inputClasses(baseClass = '', validCheck) {
    const validClass = validCheck === undefined ? '' : (validCheck ? ' valid' : ' error');
    return `form-input ${baseClass}${validClass}`;
  }

  focusInput(ev) {
    const focusable = ev.currentTarget
      .querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    focusable[0].focus();
  }

  buildInputWithProps() {
    const { name, value, valid } = this.props.inputData;
    const child = this.props.children;
    const onChange = child.props.onChange || this.props.onChange;
    let onFocus;
    if (this.props.onFocus) {
      onFocus = (ev) => this.props.onFocus(name, ev);
    }
    return React.cloneElement(child, {
      id: `inp_${name}`,
      className: this.inputClasses(child.props.className, valid),
      value,
      onFocus,
      onChange: (ev) => onChange(name, ev, false),
      onBlur: (ev) => onChange(name, ev, true),
    });
  }

  renderMsg() {
    const { msg, informative } = this.props.inputData;
    if (msg) {
      return <span className={`form-input${informative ? '__info' : '__error'}`}>{msg}</span>;
    }
    return '';
  }

  render() {
    const { name } = this.props.inputData;
    const childInput = this.buildInputWithProps();
    return (
      <div className={`FormControl ${name}${this.state.focused ? ' focused' : ''} ${this.props.className}`}
           onMouseEnter={this.isIn} onMouseLeave={this.isOut} onClick={this.focusInput}>
        {this.props.label
          ? <label htmlFor={`inp_${name}`}>{this.props.label}{childInput.props.required ? <span>*</span> : null}</label>
          : null}
        {childInput}
        {this.renderMsg()}
      </div>
    );
  }
}

FormControl.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  inputData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    valid: PropTypes.bool,
    msg: PropTypes.string,
    informative: PropTypes.bool,
  }).isRequired,
};

export default FormControl;
